import { connect } from 'react-redux';
import AuctionsFolder from 'components/auctions/AuctionsFolder';
import {
  clearImages,
  clearCurrentAuction,
  fetchAuction,
  fetchImages,
} from 'data/auctions/Auctions.actions';
import { fetchParty, clearCurrentParty } from 'data/parties/Parties.actions';
import { showAlert } from 'data/app/App.actions';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      lang: state.i18n.locale,
      auction: state.auctions.currentAuction,
      bids: state.auctions.currentAuctionBids,
      comments: state.auctions.currentAuctionComments,
      fetchingImages: state.auctions.fetchingImages,
      garageData: (state.garages.garagesData || [])[0],
      merchantData: state.parties.currentParty,
      insuranceData: state.parties.currentParty,
      images: state.auctions.images,
      loading:
        state.auctions.fetchingCurrentAuction ||
        state.auctions.fetchingCurrentAuctionBids,
      message: state.auctions.message || {},
      submitting:
        state.auctions.startingAuctions ||
        state.auctions.endingAuction ||
        state.auctions.acceptingAuction ||
        state.auctions.dispatchingAuction ||
        state.auctions.rejectingAuction ||
        state.auctions.cancellingAuctions ||
        state.auctions.creatingAuctionBids ||
        state.bids.cancelingBid,
      user: state.app.user,
    },
    state,
    'auctionStatuses',
    'bidStatuses',
    'vehicleTypes',
    'partTypes',
    'partyTypes',
    'regions',
    'taxOffices',
    'countries',
    'fuelTypes',
    'gearBoxes',
    'wheelDrives',
    'bidFileTypes',
    'imitationPartCategories',
    'usedConditionTypes',
    'applications',
    'memberships'
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchAuction: auctionId => {
      dispatch(fetchAuction(auctionId));
    },
    fetchImages: folderId => dispatch(fetchImages(folderId)),
    showAlert: (text, type, duration) => showAlert(text, type, duration),

    clearData: () => {
      dispatch(clearCurrentAuction());
      dispatch(clearCurrentParty());
      dispatch(clearImages());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuctionsFolder);
